import { TFunction } from 'i18next';
import { ComponentSettingsKpiChart, validateHeight } from '@report-content';

export default function validateKpiChart(newSettings: ComponentSettingsKpiChart, t: TFunction) {
    let message = validateHeight(newSettings, t);

    if (-1 != newSettings.measureFields.findIndex((b) => b.reference_name == newSettings.x_axis.field)) {
        message = t('kpi_chart.validation.error_date_column_can_not_be_used_in_measure');
    }
    return message;
}
